var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('HeaderComponent',{staticClass:"header"}),_c('router-view',{staticClass:"content"}),_c('footerComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }